import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useChildTokens } from './useChildTokens';

/**
 * ⭐N-pill (prototypens .star-counter). Visar barnets totala stjärnor och leder
 * till /stars vid tap. Värdet kommer från StarContext (totalEarnedStars).
 */
type StarCounterProps = {
  count: number;
};

const StarCounter = ({ count }: StarCounterProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const tokens = useChildTokens();

  return (
    <Box
      component="button"
      type="button"
      onClick={() => navigate('/stars')}
      aria-label={t('child.stars.counterAria', { count }) as string}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.75,
        bgcolor: tokens.amberLight,
        border: '2px solid',
        borderColor: 'warning.main',
        borderRadius: '20px',
        px: 1.75,
        py: 0.75,
        fontWeight: 800,
        fontSize: '1rem',
        color: 'warning.main',
        cursor: 'pointer',
        fontFamily: 'inherit',
      }}
    >
      <span aria-hidden>⭐</span>
      <span>{count}</span>
    </Box>
  );
};

export default StarCounter;
